import * as _ from 'lodash';
import React, {Fragment} from 'react';
import {connect, MapDispatchToProps, MapStateToProps} from 'react-redux';
import {CardContent, Card, Box, Grid, TextField, Button, Hidden} from "@material-ui/core";
import clsx from 'clsx';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import moment from "moment";
import {
    singleCase,
    cancelCase,
    setSingleCase,
    updateCase,
    caseFormChange,
    resetCaseForm
} from '../../vendors/actions/case'
import {scrollToElemError} from "../../vendors/utils/common";

import {
    editCase
} from '../../vendors/actions/layout'
import {caseCardClass, isMobileBrowser, PAYMENT_TYPES} from "../../vendors/utils/common";
import {getCounties} from "../../vendors/actions/static";
import {locationFormChange} from "../../vendors/actions/location";
import {notifications} from "../../elements/notificationBox";
import FileUpload from "../../component/createCase/fileUpload";
import LocationForm from "../../component/locationForm/locationForm";
import DateTime from "../../component/dateTime/dateTime";
import {
    CaseFormSerializer,
    LocationFormSerializer,
    DateFormSerializer
} from "../../vendors/utils/serializers";
import _isEqual from "lodash/isEqual";


interface OwnProps {
    Case?: any,
    Layout?: any,
    CaseTypes?: any,
    getSingleCase?: any,
    deleteCase?: any,
    cancelCase?: any,
    location?: any,
    match?: any,
    acceptLawyer?: any,
    setSingleCase?: any
    editCase?: any,
    updateCase?: any,
    caseFormChange?: any,
    resetCaseForm?: any,
    setDefaultFiles?: any,
    case_uid?: string
}

interface ConnectStateProps {
    Case: any,
    States: any,
    Counties: any,
    CaseForm: any,
    Documents: any,
    DateTime: any,
    LocationForm: any;

    [key: string]: any
}

interface ConnectDispatchProps {
    getSingleCase?: (case_uid: string) => void;
    getCounties?: (state_id: number) => void;
    cancelCase?: (data: any) => void;
    setSingleCase?: (data: any) => void;
    editCase?: (action: boolean) => void;
    updateCase?: (case_uid: string, data: any) => void;
    caseFormChange?: (data: any) => void;
    setDefaultFiles?: (data: any) => void;
    locationFormChange?: (data: any) => void;
}

interface MainState {
    caseData: any,
    loading: boolean,
    created: boolean,
    counties: any,
    cancelCase: boolean,
    notification: any,
    form: any,
    progressError: boolean
}

type HeaderProps = OwnProps & ConnectStateProps & ConnectDispatchProps;

class SingleCaseEditMode extends React.Component<HeaderProps, MainState> {
    constructor(props: any) {
        super(props);

        const {Case} = props;
        const caseData = Case.caseData || Case;

        this.state = {
            caseData,
            counties: [],
            cancelCase: false,
            created: Case.created || false,
            loading: false,
            notification: notifications.CaseStatusNotifications,
            form: {
                comment: {
                    value: '',
                    error: false
                }
            },
            progressError: false
        };

        this.props.caseFormChange({
            value: caseData.comment,
            field: 'description'
        })
    }

    static getDerivedStateFromProps(props: any, state: any) {
        const {Case, CaseForm} = props;

        if (!_isEqual(state.form.comment, CaseForm.data.description)) {
            return {
                form: {
                    comment: CaseForm.data.description
                }
            };
        }

        if (!_.isEqual(Case, state.caseData)) {
            return {
                caseData: Case?.caseData || Case,
                loading: false,
                cancelCase: false
            }
        }
        return null
    }

    componentWillUnmount(): void {
        this.props.editCase(false);
        this.props.resetCaseForm()
    }

    validateAllForms = () => {

        const {LocationForm} = this.props;

        const forms: Array<any> = [
            {form: LocationForm, key: 'locationFormChange'},
        ];

        for (const single of forms) {
            for (const prop in single.form.data) {
                const value = single.form.data[prop].value;
                const err = single.form.data[prop].error;

                if (typeof this.props[single.key] === 'function') {
                    this.props[single.key]({value, field: prop, validate: true});
                }
            }

        }
    }

    cancelEdit = () => {
        this.props.editCase(false);
    };

    save = () => {

        const {case_uid, CaseForm, Documents, DateTime, LocationForm} = this.props;
        const {caseData} = this.state;
        if (Documents.fileLoading) {
            this.setState({progressError: true});
            setTimeout(() => {
                this.setState({progressError: false})
            }, 2000)
        }

        this.validateAllForms();

        console.log(CaseForm);

        if (
            CaseForm.data.description.error ||
            Documents.fileLoading ||
            (!LocationForm.valid && caseData?.payment_type === 'single_appearance')) {
            return scrollToElemError();
        }


        if (caseData?.payment_type === 'single_appearance' && (!LocationForm.valid || !DateTime.valid)) {
            return scrollToElemError();
        }

        const data = CaseFormSerializer(CaseForm.data, true);
        const locationData = LocationFormSerializer(LocationForm.data);

        const date = DateFormSerializer(DateTime.data);
        Object.assign(data, {...locationData, ...date});

        const oldDocs = caseData.documents || [];
        const allDocs = Documents.uploads || [];
        const deletedDocs = [];
        const newDocs = [];

        for (const doc of oldDocs) {
            if (!allDocs.find((el: any) => el.name === doc.name)) {
                deletedDocs.push(doc);
            }
        }
        for (const doc of allDocs) {
            if (!oldDocs.find((el: any) => el.name === doc.name)) {
                newDocs.push(doc);
            }
        }

        this.props.updateCase(case_uid, {data, newDocs, deletedDocs});
    };

    formChange(e: any, field: string) {
        this.props.caseFormChange({
            value: e.target.value,
            field
        })
    }


    render() {
        const {caseData, loading, form} = this.state;
        const progressText = 'Upload is in process, please wait.';
        if (loading) return (<Fragment></Fragment>);
        const {CaseTypes, States, Counties} = this.props;
        const state = States.find((s: any) => s.id === caseData.state_id),
            county = Counties.find((c: any) => c.id === caseData.county_id),
            caseType = CaseTypes.find((cT: any) => cT.id === caseData.case_type_id),
            caseStatus = caseCardClass(caseData?.status),
            caseSubType = caseType ? caseType.subTypes.find((cT: any) => cT.id === caseData.case_sub_type_id) : null,
            documents = caseData?.documents;

        return (
            <Fragment>
                <Card className="single-case card-box mb-4" variant="outlined">
                    <div className={`card-indicator ${caseStatus?.className}`}/>
                    <div className={'card-header d-flex'}>
                        <div>
                            <div className="pb-3 d-flex justify-content-between single-case-name">
                                <p className={clsx('m-0', {'disabled': caseData.status === 5})}>
                                    <span className='text-uppercase'>{caseType?.name}</span>, {caseSubType?.name}
                                </p>
                            </div>
                            <div className="d-flex align-items-center justify-content-start">
                                <div
                                    className={`badge badge-${caseStatus?.className} px-2 px-lg-3 text-uppercase`}>
                                    {caseStatus?.name}
                                </div>
                                <div className="font-size-sm pl-2 pl-lg-0 px-lg-3 single-case-date">
                                    <FontAwesomeIcon icon={['far', 'clock']} className="mr-1"/>
                                    <span className='text-uppercase'>
                                        {moment(caseData.created_at).format('MMM DD, YYYY')}
                                    </span>&nbsp;
                                    at {moment(caseData.created_at).format('HH:mm A')}
                                </div>
                            </div>
                        </div>
                        <div className="ml-auto d-flex align-items-start align-items-lg-center">
                        </div>
                    </div>
                    <div className="divider mt-4 mb-2 my-lg-0 m-lg-4"/>
                    <CardContent className={clsx("px-4 py-3 case-details", {'disabled': caseData.status === 5})}>
                        <Grid container spacing={isMobileBrowser() ? 0 : 4}>
                            <Grid item xs={12} lg={5}>
                                <Box className="case-details-main position-relative">
                                    {caseData?.payment_type === 'single_appearance' &&
                                    <DateTime className={'dir-column window-overlay'} default={{
                                        time: moment.utc(caseData.date),
                                        zone: county.timeZone
                                    }}/>}
                                    <div className="disabled case-details-main-item">
                                        <p className="text">
                                            {PAYMENT_TYPES[caseData?.payment_type]} {caseData?.price !== 0 && `$${caseData?.price}`}
                                        </p>
                                        <span className="description">Pricing</span>
                                    </div>
                                    {caseData?.payment_type === 'full_case_hourly' &&
                                    <div className="case-details-main-item">
                                        <p className="text">${caseData?.price * 10}</p>
                                        <span className="description">Initial Retainer (for 10 hrs)</span>
                                    </div>}
                                    <div className="disabled case-details-main-item text-capitalize">
                                        <p className="text">{caseType?.name}, {caseSubType?.name}</p>
                                        <span className="description">Case Type, Subtype</span>
                                    </div>
                                    <div className="disabled case-details-main-item">
                                        <p className="text">{caseData?.language}</p>
                                        <span className="description">Preferred Language</span>
                                    </div>
                                    <div className="disabled case-details-main-item">
                                        <p className="text">{county?.name}, {state?.abbreviation}</p>
                                        <span className="description">County, State</span>
                                    </div>
                                    {caseData?.payment_type === 'single_appearance' && <div className="mt-2">
                                        <LocationForm inline={false} caseData={caseData} edit={true}/></div>}
                                    <Hidden smDown>
                                        <div className={`mb-4 mr-4`}>
                                            <FileUpload inline={false} defaults={documents}/>
                                        </div>
                                    </Hidden>
                                </Box>
                            </Grid>
                            <Grid item xs={12} lg={7}>
                                <div className={"mb-4 case-details-edit-description"}>
                                    <TextField
                                        value={form?.comment?.value || ''}
                                        error={!!form?.comment?.error}
                                        helperText={form?.comment?.error}
                                        fullWidth
                                        onChange={(e: any) => this.formChange(e, 'description')}
                                        id="description"
                                        label="Description"
                                        multiline
                                        rows="11"
                                        variant="outlined"
                                        inputProps={{
                                            maxLength: 4000
                                        }}
                                    />
                                </div>
                                <Hidden mdUp>
                                    <div className=''>
                                        <FileUpload inline={false} defaults={documents}/>
                                    </div>
                                </Hidden>
                            </Grid>
                            <Grid item xs={12}>
                                <div className='mb-3 mt-3 mt-md-0 pt-md-4 text-center text-sm-right'>
                                    <Button
                                        onClick={this.save}
                                        color='primary'
                                        size={isMobileBrowser() ? 'medium' : 'large'}
                                        variant="contained"
                                        className="mx-1">
                                        <span className="btn-wrapper--label">Save Changes</span>
                                    </Button>
                                    <Button
                                        onClick={this.cancelEdit}
                                        variant="outlined"
                                        size={isMobileBrowser() ? 'medium' : 'large'}
                                        className="text-black-50 ml-4 mx-1">
                                        <span className="btn-wrapper--label">Never Mind</span>
                                    </Button>
                                    {this.state.progressError && <p className='mt-2 text-error'>{progressText}</p>}
                                </div>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </Fragment>
        );
    }
}

type ConnectStateMapper = MapStateToProps<ConnectStateProps, OwnProps>

const mapStateToProps: ConnectStateMapper = (state: any) => {
    const {
        Case,
        CaseTypes,
        Modals,
        States,
        Counties,
        Layout,
        CaseForm,
        DateTime,
        LocationForm,
        Documents
    } = state;
    return {
        Case,
        CaseTypes,
        Modals,
        States,
        Counties,
        Layout,
        Documents,
        DateTime,
        LocationForm,
        CaseForm,
    }
};

type ConnectDispatchMapper = MapDispatchToProps<ConnectDispatchProps, OwnProps>

const mapDispatchToProps: ConnectDispatchMapper = (dispatch: any) => {
    return {
        getSingleCase: (case_uid: string) => dispatch(singleCase(case_uid)),
        getCounties: (state_id: number) => dispatch(getCounties(state_id)),
        cancelCase: (data: any) => dispatch(cancelCase(data)),
        setSingleCase: (data: any) => dispatch(setSingleCase(data)),
        editCase: (action: boolean) => dispatch(editCase(action)),
        updateCase: (case_uid: string, data: any) => dispatch(updateCase(case_uid, data)),
        caseFormChange: (data: any) => dispatch(caseFormChange(data)),
        resetCaseForm: () => dispatch(resetCaseForm()),
        locationFormChange: (data: any) => dispatch(locationFormChange(data)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(SingleCaseEditMode);



